/**
 * Media Service - Handles media URL generation and asset management
 */

import { MEDIA_CENTRAL } from "../../../../constants";

/**
 * Constructs Media Central URL from physicalId
 * @param physicalId - The physical ID for the media asset
 * @param extension - File extension (png, jpg, etc.)
 * @param scaleToSquare - Whether to scale image to square format using default certification icon size
 * @returns Media Central URL with proper encoding
 */
export function getMediaCentralUrl(
  physicalId: string,
  extension: string = MEDIA_CENTRAL.defaultExtension,
  scaleToSquare: boolean = false,
): string {
  if (!physicalId) {
    throw new Error("Physical ID is required for media URL generation");
  }

  // Calculate scaled size: certificationIconWidth (36) * antiBlurrinessScaleFactor (4) = 144
  const scaledSize = scaleToSquare
    ? MEDIA_CENTRAL.certificationIconWidth *
      MEDIA_CENTRAL.antiBlurrinessScaleFactor
    : null;

  // Add scale suffix if specified (e.g., ._SS144_ for 144px square)
  const scaleSuffix = scaledSize ? `._SS${scaledSize}_` : "";

  // Don't encode physicalId as Media Central expects literal characters (including ++)
  return `${MEDIA_CENTRAL.baseUrl}${physicalId}${scaleSuffix}.${extension}`;
}
